import React, { Component } from "react";
// we need to get into git
import { connect } from "react-redux";
//import axios from "axios";

//import { useRanger } from "react-ranger";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
//
import { getDomainData, getDealSpecials } from "../../actions/dealsActions";
//import styled, { createGlobalStyle } from "styled-components";



import DoubleSlider from "./DoubleSlider";
import DateSlider from "./DateSlider";
import ErrorMessageConstant from "../common/ErrorMessageConstant";
import LoadingMessage from "../common/LoadingMessage";
import isEmpty from "../common/is-empty";
import DealDisplay from "./DealDisplay";
import DealDisplayDetail from "./DealDisplayDetail";
import DealsMap from "./DealsMap";


/*
const SliderDateDisplay = styled("div")`
  display: inline-block;
  height: 12px;
  width: 90%;
  margin: 0 5%;
  color:white;
  font-size:10pt;
`;
*/

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.mmin = 0;
    this.mmax = 0;
    this.state = {
      minmax: [50, 150],
      valary: [50, 150],
      minval: 0,
      maxval: 0,

      specials_label: 'Last minute deals',
      showdetails: false,
      selected_deal: null,
      click_pos: {},
      showmap: false,
      mapgridlabel: 'map',
      errors: {}
    }; //shuttles: ["one", "two", "three"] };
    // console.log("Dashboard props", props);
    this.showDetailsFromMap = this.showDetailsFromMap.bind(this);

  }

  componentDidMount() {
    this.props.getDomainData();
  }
  processDealsSpecials = (e, which) => {
    e.preventDefault();
    let lbl = '';
    let qobj = {};
    if (which == 'lmd') {
      lbl = 'Last minute deals';
      qobj['which'] = 'checkin';
    }
    if (which == 'ppn') {
      lbl = 'Lowest price per night';
      qobj['which'] = 'ppn';
    }
    this.setState({ specials_label: lbl });
    this.props.getDealSpecials(qobj);
  }



  // array of min max
  /*
  goToDeals = (minmax, semillis) => {
    // console.log('dashboard going to deals via query strting main minmax ', minmax);
    let hobj = {
      pathname: '/dealsmain',
      minMaxData: minmax,
      startEndMillis: semillis
    }
    this.props.history.push(hobj);
  };
*/
  goToMore = () => {
    // console.log('dashboard going to deals via query strting main minmax ', minmax);
    let hobj = {
      pathname: '/dealsmain'
    }
    this.props.history.push(hobj);
  };



  showDetailsFromMap = (e, id) => {
    console.log('details from map', id);
    let obj = this.props.deals.deals.find((item) => item.id === id);
    this.showDetails(e, obj);
  }
  showDetails = (e, obj) => {
    e.preventDefault();
    // console.log('we selected deal num ', id);
    //console.log('we selected deal num ', e.pageX, e.pageY, obj['id']);
    //let sd = this.props.deals.deals[0];
    const sd = obj; //this.props.deals.deals.find((item) => item.id === id)
    let posobj = {};
    posobj['click_y'] = e.pageY;
    posobj['click_x'] = e.pageX;

    this.setState({ showdetails: true, selected_deal: sd, click_pos: posobj });

    // var d = document.getElementById('dealdisplaydetailsdiv');
    //d.style.left = x_pos+'px';
    //d.style.top = e.pageY + 'px';

  }
  onCloseDetail = (e) => {
    e.preventDefault();
    this.setState({ showdetails: false });
  }



  showMap = (e) => {
    e.preventDefault();
    if (this.state.showmap === true) {
      this.setState({ showmap: false, mapgridlabel: 'map' });
    } else {
      this.setState({ showmap: true, mapgridlabel: 'grid' });
    }
  }

  gotoBooking = (e, url) => {
    e.preventDefault();
    let msg = 'User will be taken to the deal booking site. ' + url;
    this.setState({ showdetails: false });
    confirmAlert({
      title: 'About to Book',
      message: msg,
      childrenElement: () => <div style={{ width: "100px", border: "1px solid black" }}>Custom UI</div>,
      buttons: [
        {
          label: 'Book',
          onClick: () => {
            alert('Click Yes');

          }
        },
        {
          label: 'Cancel',
          onClick: () => alert('Click No')
        },
        {
          label: 'Maybe',
          onClick: () => alert('Click Maybe')
        }
      ]
    });
  }




  render() {
    //  console.log('DOING A DASBOARD RENDER');
    let user = {};
    user["name"] = "Jim";
    let { minmax } = this.state;
    let { valary } = this.state;
    if (!this.props.deals.domain_data) {
      return (<div>Loading</div>)
    }

    let { startci } = this.state;
    let { endci } = this.state;
    let { specials_label } = this.state;
    let { showdetails } = this.state;
    let { selected_deal } = this.state;
    let { click_pos } = this.state;
    let { showmap } = this.state;
    let { mapgridlabel } = this.state;

    //let { showmaplbl } = this.state;

    // console.log('DOING A DASBOARD RENDER state valary', valary);
    // minmax = this.props.deals.minmax;
    minmax[0] = this.props.deals.min_ppn;
    minmax[1] = this.props.deals.max_ppn;

    let deals = this.props.deals.deals;

    let range = [50, 500];

    let drange = [0, 56];
    let dvalary = [0, 4];
    let perrors = this.props.errors;

    let nomap = true;
    // console.log('perrors are', perrors);

    //let valary = [100, 400];
    // console.log('dashboard render dd ', dd);
    // minmax[0] = parseInt(dd['ppn']);
    /*
    backgroundColor: "#231259",
          color: "white",
          */
    let template = deals.map((deal, index) => (
      <div key={index}>
        <DealDisplay
          deal={deal}
          showDetails={this.showDetails}
        />
      </div>
    ));


    return (
      <div>
        <div className="jumbotron_ld" style={{ paddingTop: "20px" }}>


          <div className="dashboardmajor"  >
            <h4 style={{ paddingBottom: "15px" }}>Welcome to Lodging Deals</h4>

            <div className="row">
              <div className="col-md-4">
                <a
                  className="btn btn-sm btn-info widdash"
                  href="#"
                  onClick={(e) => {
                    this.processDealsSpecials(e, 'lmd');
                  }}
                >
                  Last minute deals
            </a>
                {/* <a
                  className="btn btn-sm btn-info widdash"
                  href="#"
                  onClick={(e) => {
                    this.gotoBooking(e, 'url of the booking site');
                  }}
                >
                  booking
            </a> */}
              </div>
              <div className="col-md-4">
                <a
                  className="btn btn-sm btn-info widdash"
                  href="#"
                  onClick={(e) => {
                    {
                      {
                        this.processDealsSpecials(e, 'ppn');
                      }
                    }
                  }}
                >
                  Lowest price per night
            </a>
              </div>

              <div className="col-md-4">
                <a
                  className="btn btn-sm btn-info widdash"
                  href="#"
                  onClick={() => {
                    {
                      {
                        this.goToMore();
                      }
                    }
                  }}
                >
                  More...
            </a>
              </div>
            </div>
            <div id='dealdisplaydetailsdiv'>
              {showdetails ? (
                <DealDisplayDetail
                  deal={selected_deal}
                  onClose={this.onCloseDetail}
                  gotoBooking={this.gotoBooking}
                  click_pos={click_pos}
                />
              ) : (null)}
            </div>


          </div>

          <div className="dashboardminor" style={{ marginBottom: "10px" }}>
            <div className="row">
              <div className="col-md-2">&nbsp;</div>
              <div className="col-md-8">
                {specials_label}
              </div>
              <div className="col-md-2">
                <span><a className="btn btn-xs btn-info" href="#" onClick={(e) => this.showMap(e)} >
                  {mapgridlabel}

                </a></span>
              </div>
            </div>
          </div>

          {(this.props.deals.isloading) ? (<LoadingMessage />) : null}

          {(!isEmpty(perrors)) ? (<ErrorMessageConstant message={perrors['message']} />) : null}

          {!showmap ? (<div className="flex_base">
            {template}
          </div>) : (
              <div className="mapdisplay" style={{ width: "95%", margin: "10px auto" }}>
                {/* <div className="row">
                  <div className="col-md-4">
                    <div style={{ height: "715px", overflowY: "scroll" }}>
                      {template}
                    </div>
                  </div>
                  <div className="col-md-8">
                    <DealsMap workdeals={deals} showDetailsFromMap={this.showDetailsFromMap} />
                  </div>
                </div> */}
                <div>
                  <div style={{ width: "310px", float: "left", height: "715px", overflowY: "scroll" }}>
                    {template}
                  </div>
                  <div >
                    <DealsMap workdeals={deals} showDetailsFromMap={this.showDetailsFromMap} />
                  </div>
                </div>
              </div>
            )}



        </div >
        {/* beginning stuff */}

        {/* <div className='flex_base'>
          <div className='flex_two_column_left'>
            {template}
          </div>

          <div className='flex_two_column_right'>
            <DealsMap />
          </div>
        </div> */}


        {/* <div style={{ width: "90%", border: "1px solid black", height: "800px", margin: "0px auto" }}>

          <div style={{ width: "30%", float: "left", height: "700px", overflowY: "scroll", paddingLeft: "0px" }}>
            {template}
          </div>
          <div style={{ width: "70%", float: "right" }}>
            <DealsMap />
          </div>
        </div> */}
        {/* <div style={{ width: "95%", border: "0px solid black", margin: "0px auto" }}>
          <div className="row">
            <div className="col-md-3">
              <div style={{ height: "700px", overflowY: "scroll" }}>
                {template}
              </div>
            </div>
            <div className="col-md-9">
              <DealsMap />
            </div>
          </div>
        </div> */}

        {/* <div style={{ width: "30%", float: "left", height: "700px", overflowY: "scroll", paddingLeft: "0px" }}>
            {template}
          </div>
          <div style={{ width: "70%", float: "right" }}>
            <DealsMap />
          </div>
        </div> */}

        {/* end stuff */}


      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  deals: state.deals,
  errors: state.errors,
});

export default connect(mapStateToProps, { getDomainData, getDealSpecials })(Dashboard);

//export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/deals/Dashboard.js